angular.module("UI8.components").component("affiliates", {
  template: `
    <div class="seller">
      <img class="seller__background" src="/img/affiliate.jpg" alt="Background" />
      <div class="seller__container container">
        <div class="seller__head">
          <h1 class="seller__title">Become an affiliate</h1>
          <div class="seller__description">Join our affiliate program by applying using the form below.</div>
        </div>
        <div class="seller__auth auth auth--author">
          <div class="auth__background">
            <img src="/img/auth-affiliate.jpg" alt="Sign in" />
          </div>
          <div class="auth__container" ng-if="!$ctrl.isSuccess">
            <div class="auth__title">Apply to join</div>
            <div class="field">
              <div class="field__label">Email</div>
              <input class="field__input tab-email" ng-class="{error: $ctrl.emailError}" placeholder="designer@example.com" ng-keydown="$ctrl.emailError = false" type="email" name="email" ng-model="$ctrl.seller.email" ng-pattern="/^[_a-z0-9-]+(.[_a-z0-9-]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,15})$/i" required>
            </div>
            <div class="field">
              <div class="field__label">Full name</div>
              <input class="field__input" ng-class="{error: $ctrl.fullNameError}" placeholder="Jamie Davis" ng-keydown="$ctrl.fullNameError = false" type="text" name="full_name" ng-model="$ctrl.seller.full_name" required>
            </div>
            <div class="field">
              <div class="field__label">Link to website promoting UI8</div>
              <input class="field__input" ng-class="{error: $ctrl.promotingLinkError}" placeholder="https://mywebsite.com" ng-keydown="$ctrl.promotingLinkError = false" type="text" name="promoting_link" ng-model="$ctrl.seller.promoting_link" required>
            </div>
            <div class="field">
              <div class="field__label">Website description</div>
              <textarea class="field__textarea" ng-class="{error: $ctrl.websiteDescriptionError}" placeholder="What is your website about?" ng-keydown="$ctrl.websiteDescriptionError = false" name="website_description" ng-model="$ctrl.seller.website_description" required></textarea>
              <input type="text" ui8-go-tab='.tab-email' />
            </div>
            <button class="btn btn--submit" ng-if="!$ctrl.isSubmitting" ng-click="$ctrl.submit()">Apply</button>
            <div class="loader" ng-if="$ctrl.isSubmitting"></div>
          </div>
          <div class="auth__container" ng-if="$ctrl.isSuccess">
            <div class="auth__title">Application under review</div>
            <div class="auth__content">
              <p>Thank you for submitting your application to become a part of the UI8 family.</p>
              <p>Your application is undergoing a thorough review, and we will be in touch with you via email within the next 1-3 business days with our decision and any subsequent steps.</p>
            </div>
          </div>
        </div>
        <div class="faq">
          <h2 class="faq__title">Frequently asked questions</h2>
          <div class="faq__list">
            <div class="faq__item">
              <h3 class="faq__head">What is the acceptance criteria?</h3>
              <div class="faq__body">You must have an industry-relevant website online.</div>
            </div>
            <div class="faq__item">
              <h3 class="faq__head">How much do I earn for sales?</h3>
              <div class="faq__body">You earn 40% commission on individual product sales. Subscription sales such as All Access pass are excluded and not counted as part of revenue sharing.</div>
            </div>
            <div class="faq__item">
              <h3 class="faq__head">When and how do I get paid?</h3>
              <div class="faq__body">Payments are fully automated via PayPal, taking place at the end of each month as long as you have a minimum balance of $100.00 in your account. Please be sure to update your payment settings with a valid PayPal email address to avoid delays.</div>
            </div>
            <div class="faq__item">
              <h3 class="faq__head">For how long do you track referrals?</h3>
              <div class="faq__body">We track referrals for up to 6 months in order to maximize your earning potential.</div>
            </div>
            <div class="faq__item">
              <h3 class="faq__head">How long will it take to review my application?</h3>
              <div class="faq__body">Our review process could take 1-2 business days upon submission. After the review process we will reach out to you via email with our decision and subsequent steps to open your affiliate account.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

  controller: function ($http) {
    var ctrl = this;
    ctrl.isSubmitting = false;

    ctrl.$onInit = function () {
      if (ctrl.user) {
        ctrl.seller = ctrl.user;
        ctrl.seller.full_name =
          ctrl.user.first_name && ctrl.user.last_name
            ? `${ctrl.user.first_name} ${ctrl.user.last_name}`
            : "";
      } else {
        ctrl.seller = {};
      }

      window.scrollTo(0, 0);

      // faq
      $(".faq__head").on("click", function () {
        $(this).toggleClass("active");
        $(this).next().slideToggle();
      });
    };

    ctrl.$destroy = function () {
      $(".faq__head").off();
    };

    // submit the form
    ctrl.submit = function () {
      if (!validateEmail(ctrl.seller.email)) return (ctrl.emailError = true);
      if (!ctrl.seller.full_name) return (ctrl.fullNameError = true);
      if (!ctrl.seller.promoting_link) return (ctrl.promotingLinkError = true);
      if (!ctrl.seller.website_description)
        return (ctrl.websiteDescriptionError = true);

      ctrl.isSubmitting = true;

      var params = {
        full_name: ctrl.seller.full_name,
        email: ctrl.seller.email,
        promoting_link: ctrl.seller.promoting_link,
        website_description: ctrl.seller.website_description,
      };

      return $http.post("/api/affiliates/apply", params).then(
        function () {
          ctrl.isSubmitting = false;
          ctrl.isSuccess = true;
        },
        function () {
          ctrl.isSubmitting = false;
          ctrl.isError = true;
        }
      );
    };

    function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },

  bindings: {
    user: "<",
  },
});
